import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  subtitleWrap: FelaCSS;
  subtitleIconWrap: FelaCSS;
  content: FelaCSS;
  title: FelaCSS;
  subtitleWrapOuter: FelaCSS;
  buttonWrap: FelaCSS;
}

const styles = ({ showSubtitle }: { showSubtitle: boolean }): IStyles => ({
  wrapper: {
    paddingTop: '20px',
    paddingRight: '20px',
    paddingBottom: '20px',
    paddingLeft: '20px',
    marginBottom: '30px',
  },

  subtitleWrap: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: '0',
    marginBottom: '11px',
    fontDefaultSemiBold: 18,
    lineHeight: '1.1em',
    color: colors.alto,
  },

  subtitleIconWrap: {
    justifyContent: 'center',
    marginRight: '5px',
  },

  content: {
    marginTop: showSubtitle ? '30px' : '20px',

    maxWidthTabletSm: {
      marginTop: '4px',
    },
  },

  title: {
    marginTop: '0',
    fontDefaultSemiBold: 22,
  },

  subtitleWrapOuter: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },

  buttonWrap: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingTop: '7px',
    paddingBottom: '7px',
  },
});

export default styles;
